import * as React from "react";
import * as LanguageTexts from "@genesys/shared/lib/language-texts";
import { additionalSystemSelectionsDef } from "../definitions";
import { StyledH3 } from "../local-elements";
import { InternalProps } from "../types";

export function AdditionalSelections(props: InternalProps) {
  const { sharedState, propertyDefinitions, renderPropertySelector } = props;
  return (
    <div>
      <StyledH3>
        {sharedState.translate(
          LanguageTexts.globalPropertyName("mlcadditionalsystemselections")
        )}
      </StyledH3>

      {renderPropertySelector(
        additionalSystemSelectionsDef(propertyDefinitions),
        undefined,
        "MoistureLoadTool.SystemConfiguration"
      )}
    </div>
  );
}
